import { cn } from '@/lib/utils';
import type { IndicatorReading, Level } from '@/lib/assessment/namatAssessment';

// One look for a health indicator's level everywhere it is shown: examiner,
// doctor, admin and the beneficiary (#91). The level comes from
// readIndicators; nothing here decides it.

const LEVEL_STYLE: Record<Level, string> = {
  good: 'bg-green-100 text-green-800',
  acceptable: 'bg-yellow-100 text-yellow-800',
  bad: 'bg-red-100 text-red-800',
};

type T = (key: string) => string;

/** The level pill; BMI shows its category. */
export function IndicatorBadge({ reading, t, className }: { reading: IndicatorReading; t: T; className?: string }) {
  if (!reading.level) return null;
  const label =
    reading.key === 'bmi' && reading.bmiCategory
      ? t(`common.health.bmiCategory.${reading.bmiCategory}`)
      : t(`common.health.level.${reading.level}`);
  return (
    <div className={cn('flex items-center text-xs', className)} data-testid={`indicator-${reading.key}`}>
      <span className={cn('rounded-full px-2 py-0.5 font-medium', LEVEL_STYLE[reading.level])}>{label}</span>
    </div>
  );
}
